import { HoverCard, HoverCardContent, HoverCardTrigger } from '@/components/ui/hover-card';
import { cn } from '@/lib/tailwind-utils';
import { ReactNode } from 'react';

interface ArrowTooltipProps {
  trigger: ReactNode;
  children: ReactNode;
  position?: 'top' | 'right' | 'bottom' | 'left';
}

export const ArrowTooltip = ({ trigger, children, position = 'top' }: ArrowTooltipProps) => {
  const arrowPositions = {
    top: [
      'before:left-1/2 before:top-full before:-translate-x-1/2',
      'before:border-x-[7px] before:border-x-transparent',
      'before:border-t-[7px] before:border-t-black/60',
    ],
    bottom: [
      'before:left-1/2 before:bottom-full before:-translate-x-1/2',
      'before:border-x-[7px] before:border-x-transparent',
      'before:border-b-[7px] before:border-b-black/60',
    ],
    left: [
      'before:left-full before:top-1/2 before:-translate-y-1/2',
      'before:border-y-[7px] before:border-y-transparent',
      'before:border-l-[7px] before:border-l-black/60',
    ],
    right: [
      'before:right-full before:top-1/2 before:-translate-y-1/2',
      'before:border-y-[7px] before:border-y-transparent',
      'before:border-r-[7px] before:border-r-black/60',
    ],
  };

  return (
    <HoverCard openDelay={0}>
      <HoverCardTrigger>{trigger}</HoverCardTrigger>
      <HoverCardContent
        side={position}
        align="center"
        className={cn(
          'relative w-auto mx-0 my-1 px-2 py-2 bg-black/60 text-white text-center text-sm font-normal rounded-sm border-none shadow-sm',
          "before:content-[''] before:absolute",
          ...arrowPositions[position],
        )}
      >
        {children}
      </HoverCardContent>
    </HoverCard>
  );
};
